// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.visibility-hidden {
  visibility: hidden;
}

.table-responsive {
  -webkit-overflow-scrolling: touch;
}

table {
  max-width: 960px;
  border-collapse: collapse;
  border-spacing: 0;
}

td,
th {
  border: 1px solid var(--surface-100);
}
td:nth-child(1),
th:nth-child(1) {
  border-right: 1px solid var(--primary-color);
}
td:nth-child(2),
th:nth-child(2) {
  border-top-width: 0;
  border-bottom-width: 0;
  border-color: var(--primary-color);
  background: #373737;
  border-left: 1px solid var(--primary-color);
}
@media only screen and (max-width: 1199px) {
  td:nth-child(2):nth-child(2),
  th:nth-child(2):nth-child(2) {
    border-right-width: 2px;
    border-left-width: 2px;
  }
}

th:first-child {
  border-top-width: 0;
  border-left-width: 0;
}

tr:first-child > th:nth-child(2),
tr:last-child > td:nth-child(2) {
  position: relative;
}
tr:first-child > th:nth-child(2):before,
tr:last-child > td:nth-child(2):before {
  content: "";
  left: -1px;
  width: calc(100% + 2px);
  height: 20px;
  position: absolute;
  border-color: var(--primary-color);
  border-style: solid;
  background: #373737;
}
@media only screen and (max-width: 1199px) {
  tr:first-child > th:nth-child(2):before,
  tr:last-child > td:nth-child(2):before {
    left: -2px;
    right: -2px;
  }
}

tr:first-child > th:nth-child(2):before {
  content: "";
  top: -20px;
  border-width: 1px 1px 0;
}
@media only screen and (max-width: 1199px) {
  tr:first-child > th:nth-child(2):before {
    top: -20px;
    border-width: 2px 2px 0;
  }
}

tr:last-child > td:nth-child(2):before {
  content: "";
  bottom: -20px;
  top: initial;
  border-width: 0 1px 1px;
}
@media only screen and (max-width: 1199px) {
  tr:last-child > td:nth-child(2):before {
    bottom: -20px;
    border-width: 0 2px 2px;
  }
}

tr > td:first-child,
tr > th:first-child {
  min-width: 200px;
}

tr > td:not(:first-child),
tr > th:not(:first-child) {
  min-width: 150px;
}
@media only screen and (max-width: 1199px) {
  tr > td:not(:first-child),
  tr > th:not(:first-child) {
    min-width: 100px;
  }
}

.fa-regular {
  border: 6px solid;
}
.fa-regular:before {
  position: relative;
  top: 6px;
}
@media only screen and (max-width: 1199px) {
  .fa-regular {
    border: 3px solid;
  }
  .fa-regular:before {
    position: relative;
    top: 2px;
  }
}

[data-value] {
  line-height: 1;
}
[data-value][data-value=A] {
  color: #9bd770;
}
[data-value][data-value=B] {
  color: #d7b470;
}
[data-value][data-value=C] {
  color: #eb6464;
}

.fa-check {
  color: #9bd770;
}

.fa-times {
  color: #eb6464;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/home/components/seo/seo.component.scss"],"names":[],"mappings":"AAOA;EACE,kBAAA;AANF;;AASA;EACE,iCAAA;AANF;;AASA;EACE,gBAAA;EACA,yBAAA;EACA,iBAAA;AANF;;AASA;;EAEE,oCAAA;AANF;AAQE;;EACE,4CAAA;AALJ;AAQE;;EACE,mBAAA;EACA,sBAAA;EACA,kCAAA;EACA,mBAAA;EACA,2CAAA;AALJ;AA3BE;EAmCI;;IACE,uBAAA;IACA,sBAAA;EAJN;AACF;;AASA;EACE,mBAAA;EACA,oBAAA;AANF;;AASA;;EAEE,kBAAA;AANF;AAQE;;EACE,WAAA;EACA,UAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,kCAAA;EACA,mBAAA;EACA,mBAAA;AALJ;AAvDE;EAoDA;;IAWI,UAAA;IACA,WAAA;EAHJ;AACF;;AAQE;EACE,WAAA;EACA,UAAA;EACA,uBAAA;AALJ;AApEE;EAsEA;IAMI,UAAA;IACA,uBAAA;EAJJ;AACF;;AASE;EACE,WAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;AANJ;AAjFE;EAmFA;IAOI,aAAA;IACA,uBAAA;EALJ;AACF;;AASA;;EAEE,gBAAA;AANF;;AASA;;EAEE,gBAAA;AANF;AAjGE;EAqGF;;IAKI,gBAAA;EAJF;AACF;;AAOA;EACE,iBAAA;AAJF;AAME;EACE,kBAAA;EACA,QAAA;AAJJ;AA/GE;EA8GF;IASI,iBAAA;EAJF;EAME;IACE,kBAAA;IACA,QAAA;EAJJ;AACF;;AAQA;EACE,cAAA;AALF;AAOE;EACE,cAAA;AALJ;AAQE;EACE,cAAA;AANJ;AASE;EACE,cAAA;AAPJ;;AAWA;EACE,cAAA;AARF;;AAWA;EACE,cAAA;AARF","sourcesContent":["// Mixins pour les breakpoints\r\n@mixin md {\r\n  @media only screen and (max-width: 1199px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n.visibility-hidden {\r\n  visibility: hidden;\r\n}\r\n\r\n.table-responsive {\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\ntable {\r\n  max-width: 960px;\r\n  border-collapse: collapse;\r\n  border-spacing: 0;\r\n}\r\n\r\ntd,\r\nth {\r\n  border: 1px solid var(--surface-100);\r\n\r\n  &:nth-child(1) {\r\n    border-right: 1px solid var(--primary-color);\r\n  }\r\n\r\n  &:nth-child(2) {\r\n    border-top-width: 0;\r\n    border-bottom-width: 0;\r\n    border-color: var(--primary-color);\r\n    background: #373737;\r\n    border-left: 1px solid var(--primary-color);\r\n\r\n    @include md {\r\n      &:nth-child(2) {\r\n        border-right-width: 2px;\r\n        border-left-width: 2px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\nth:first-child {\r\n  border-top-width: 0;\r\n  border-left-width: 0;\r\n}\r\n\r\ntr:first-child > th:nth-child(2),\r\ntr:last-child > td:nth-child(2) {\r\n  position: relative;\r\n\r\n  &:before {\r\n    content: \"\";\r\n    left: -1px;\r\n    width: calc(100% + 2px);\r\n    height: 20px;\r\n    position: absolute;\r\n    border-color: var(--primary-color);\r\n    border-style: solid;\r\n    background: #373737;\r\n\r\n    @include md {\r\n      left: -2px;\r\n      right: -2px;\r\n    }\r\n  }\r\n}\r\n\r\ntr:first-child > th:nth-child(2) {\r\n  &:before {\r\n    content: \"\";\r\n    top: -20px;\r\n    border-width: 1px 1px 0;\r\n\r\n    @include md {\r\n      top: -20px;\r\n      border-width: 2px 2px 0;\r\n    }\r\n  }\r\n}\r\n\r\ntr:last-child > td:nth-child(2) {\r\n  &:before {\r\n    content: \"\";\r\n    bottom: -20px;\r\n    top: initial;\r\n    border-width: 0 1px 1px;\r\n\r\n    @include md {\r\n      bottom: -20px;\r\n      border-width: 0 2px 2px;\r\n    }\r\n  }\r\n}\r\n\r\ntr > td:first-child,\r\ntr > th:first-child {\r\n  min-width: 200px;\r\n}\r\n\r\ntr > td:not(:first-child),\r\ntr > th:not(:first-child) {\r\n  min-width: 150px;\r\n\r\n  @include md {\r\n    min-width: 100px;\r\n  }\r\n}\r\n\r\n.fa-regular {\r\n  border: 6px solid;\r\n\r\n  &:before {\r\n    position: relative;\r\n    top: 6px;\r\n  }\r\n\r\n  @include md {\r\n    border: 3px solid;\r\n\r\n    &:before {\r\n      position: relative;\r\n      top: 2px;\r\n    }\r\n  }\r\n}\r\n\r\n[data-value] {\r\n  line-height: 1;\r\n\r\n  &[data-value=\"A\"] {\r\n    color: #9bd770;\r\n  }\r\n\r\n  &[data-value=\"B\"] {\r\n    color: #d7b470;\r\n  }\r\n\r\n  &[data-value=\"C\"] {\r\n    color: #eb6464;\r\n  }\r\n}\r\n\r\n.fa-check {\r\n  color: #9bd770;\r\n}\r\n\r\n.fa-times {\r\n  color: #eb6464;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
